import React, { useRef, useState, useEffect } from 'react';
import './Daily_income.scss';
import moment from "moment";
import socket from '../../components/socket/socket';

const Daily_income_new = () => {
    const [data, setData] = useState([]);
    
    useEffect(() => {
        console.log("Component mounted: fetching income");

        const userId = localStorage.getItem("user_id");
        if (!userId) {
            console.error("No user_id found in localStorage.");
            return;
        }

        // Emit the event
        socket.emit("incomedropdown", { user_id: userId });

        // Listen for response
        const handleResponse = (response) => {
            console.log("Socket response:", response);
            if (response?.data) {
                setData(response.data);
            } else {
                console.warn("No data received");
            }
        };

        socket.on(userId, handleResponse);

        // Clean up the listener on unmount
        // return () => {
        //     socket.off(userId, handleResponse);
        // };
    }, []); // Run only once on mount

    return (
        <div className="container-fluid myprofile py-5">
            <h4 className="text-white">Incentive Amount</h4>
            <div className="table-responsive mt-4">
                <table className="table table-light table-hover shadow">
                    <thead>
                        <tr>
                            <th scope="col">Sl no</th>
                            <th scope="col">Income Received</th>
                            <th scope="col">Date</th>
                            <th scope="col">Income Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((details, index) => (
                                <tr key={index}>
                                    <th scope="row">{index + 1}</th>
                                    <td>{details.i_income}</td>
                                    <td>{moment(details.i_date).format("DD MMM YYYY")}</td>
                                    <td>{details.i_role}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center">No data available</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Daily_income_new;
